// shadowed constants for RelatedArticleCard
export const articleShortTitleTextLength = 45;
